import { render, staticRenderFns } from "./PxAdminsText.vue?vue&type=template&id=f45589bc&"
import script from "./PxAdminsText.vue?vue&type=script&lang=js&"
export * from "./PxAdminsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports